import { Roles } from '@hap/constants'

export interface Permission {
  action: string
  resource: string
}

export function hasPermission(input: {
  permissions: Permission[]
  resource: Roles.ResourceType
  actions: Roles.Permission[]
}): boolean {
  return input.permissions.some(
    (p) =>
      input.actions.includes(p.action as Roles.Permission) &&
      input.resource === (p.resource as Roles.ResourceType),
  )
}
